import React, {useEffect} from 'react';
import {Button, FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import {useParams} from "react-router-dom";
import { useTranslation } from "react-i18next";

interface HelpWithOrderFormComponentProps {
    handleButtonFormSendHelpMessage: () => void;
    handleRadioChange: (value: string) => void;
    selectedProblem: string;
    worrySearch: string;
    setWorrySearch: (value: string) => void;
}

const HelpWithOrderFormComponent = (props: HelpWithOrderFormComponentProps) => {
    const { t } = useTranslation();
    
    const causedProblemsRadio = [
        { id: 1, title: t('helpWithOrder.order'), value: 'Order' },
        { id: 2, title: t('helpWithOrder.food'), value: 'Food' },
        { id: 3, title: t('helpWithOrder.time'), value: 'Time' },
        { id: 4, title: t('helpWithOrder.payment'), value: 'Payment' },
        { id: 5, title: t('helpWithOrder.somethingElse'), value: 'Something else' },
    ];
    
    return (
        <div style={{width: "100%"}}>
            <form className="helpWithOrderDataForm__container_content_form help_problem">
                <div className="helpWithOrderDataForm__container_content_form_input_caused_problem_wrap">
                    <div className="helpWithOrderDataForm__container_content_form_input_caused_problem_title">
                        <span>{t('helpWithOrder.whatCausedProblems')}</span>
                    </div>

                    <div className="helpWithOrderDataForm__container_content_form_input_caused_problem_radio_wrap">
                        <FormControl className="helpWithOrderDataForm__container_content_form_input_caused_problem_radio_form_control">
                            <RadioGroup
                                className="helpWithOrderDataForm__container_content_form_input_caused_problem_radio_form_group"
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                            >
                                {
                                    causedProblemsRadio.map((item, index) => (
                                        <FormControlLabel
                                            key={index}
                                            className="helpWithOrderDataForm__container_content_form_input_caused_problem_radio_form_control_label"
                                            value={item.value}
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: "#E8E7E7",
                                                        '&.Mui-checked': {
                                                            color: "#4BAF9D",
                                                        },
                                                    }}
                                                />
                                            }
                                            label={item.title}
                                            onChange={(e) => props.handleRadioChange(item.value)}
                                        />
                                    ))
                                }
                            </RadioGroup>
                        </FormControl>
                    </div>
                </div>
            </form>

            <div className="profileSectionDataForm__container-button-btn_wrap">
                <Button
                    className="profileSectionDataForm__container-button-btn save"
                    variant="contained"
                    onClick={props.handleButtonFormSendHelpMessage}
                    disabled={!(props.selectedProblem)}
                >
                    <span>{t('buttons.next')}</span>
                </Button>
            </div>
        </div>
    );
};

export default HelpWithOrderFormComponent;